import React from 'react';
import NewProjectWizardCard from './NewProjectWizardCard';
import styles from './css/index.module.css';
import checkIcon from './assets/check.svg';

const PREPARING_ITEMS = [
    'Reviewing confirmed project scope',
    'Reviewing VDR structure',
    'Preparing workstream information requests',
    'Checking for duplicate requests',
];

const SetupIrlPreparing = ({ prepare, onComplete }) => {
    const [activeIndex, setActiveIndex] = React.useState(0);

    React.useEffect(() => {
        let cancelled = false;
        let stepTimer;
        const run = async () => {
            stepTimer = setInterval(() => {
                setActiveIndex(index => Math.min(index + 1, PREPARING_ITEMS.length - 1));
            }, 900);
            try {
                if (typeof prepare === 'function') {
                    await prepare();
                }
            } finally {
                clearInterval(stepTimer);
            }
            if (!cancelled) {
                setActiveIndex(PREPARING_ITEMS.length);
                onComplete();
            }
        };
        run();
        return () => {
            cancelled = true;
            clearInterval(stepTimer);
        };
    }, [prepare, onComplete]);

    return (
        <NewProjectWizardCard
            title="Preparing initial information requests"
            subtitle="Lens is using the confirmed project context, workstreams and VDR structure to prepare an initial Information Request List."
            hideProgress
            hideFooter
            showHeaderDivider
        >
            <ol className={styles.preparingList}>
                {PREPARING_ITEMS.map((label, index) => {
                    const status = index < activeIndex ? 'done' : index === activeIndex ? 'active' : 'pending';
                    const statusClass = status === 'done' ? 'Done' : status === 'active' ? 'Active' : 'Pending';
                    return (
                        <li key={label} className={`${styles.preparingItem} ${styles[`preparingItem${statusClass}`]}`}>
                            <span className={`${styles.preparingIcon} ${styles[`preparingIcon${statusClass}`]}`} aria-hidden="true">
                                {status === 'done' ? (
                                    <img src={checkIcon} alt="" width={10} height={8} className={styles.preparingCheck} />
                                ) : null}
                                {status === 'active' ? <span className={styles.preparingDot} /> : null}
                            </span>
                            <span className={styles.preparingLabel}>{label}</span>
                        </li>
                    );
                })}
            </ol>
        </NewProjectWizardCard>
    );
};

export default SetupIrlPreparing;
